import { render, staticRenderFns } from "./TheTeam.vue?vue&type=template&id=66615c87&scoped=true&"
var script = {}
import style0 from "./TheTeam.vue?vue&type=style&index=0&id=66615c87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66615c87",
  null
  
)

export default component.exports